import { Stack, Typography } from "@mui/material";
import type { GridRenderCellParams, GridRowId } from "@mui/x-data-grid-premium";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import type { PropsWithChildren } from "react";
import { ExpandCollapseButton } from "../../../reporting/report-lists/reports/components/ExpandCollapseButton.tsx";

import type { OrganizationReportInfo } from "../../../../../api/types/svTypes.ts";

interface Props {
  expanded: boolean;
  params: GridRenderCellParams<OrganizationReportInfo, string, unknown>;
  onExpandToggle: (expanded: boolean, rowId: GridRowId) => void;
}
const GroupNameCore = ({ expanded, params, children, onExpandToggle }: PropsWithChildren<Props>) => {
  const gridApi = useGridApiContext();

  if (params.rowNode.type !== "group") {
    return null;
  }

  const reportsNumber =
    params.rowNode.depth === 0
      ? gridApi.current.getRowGroupChildren({ groupId: params.rowNode.id }).length
      : params.rowNode.children.length;

  return (
    <Stack direction={"row"} sx={{ alignItems: "center", gap: 1, pl: params.rowNode.depth * 2 }}>
      <ExpandCollapseButton
        expanded={expanded}
        onClick={(value) => {
          onExpandToggle(value, params.rowNode.id);
          gridApi.current.setRowChildrenExpansion(params.rowNode.id, value);
        }}
      />
      {children}
      <Typography variant="subtitle2">
        {params.value} ({reportsNumber})
      </Typography>
    </Stack>
  );
};

export default GroupNameCore;
